import { render, staticRenderFns } from "./v-payment-instrument.vue?vue&type=template&id=3a2b4898&"
import script from "./v-payment-instrument.vue?vue&type=script&lang=js&"
export * from "./v-payment-instrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports